import React from 'react'
import { connect } from 'react-redux'


class MessagePage extends React.Component {

  render() {
    // const { mission_page } = this.props
    // return (
    //   <h3>
    //     {mission_page.information}
    //   </h3>
    // )
    return null
  }

}

MessagePage.propTypes = {
  mission_page: React.PropTypes.shape({
    id: React.PropTypes.number.isRequired,
  }).isRequired,
}

const mapStateToProps = state => ({
  ...state,
})

const mapDispatchToProps = () => ({
})


export default connect(mapStateToProps, mapDispatchToProps)(MessagePage)



// WEBPACK FOOTER //
// ./src/components/MissionShow/MissionPage/MessagePage/index.jsx